import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ProgressDialog } from "../plungerPage/progressPopup";
import {
  C5_REGISTERS,
  getSetpoints,
  requestSetpoints,
} from "../../utils/controlConfig";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

export const SetpointsCard = ({ unitId, data, type, fetchData }) => {
  const { pathname } = useLocation();
  const isZXUR = pathname.startsWith("/ZXUR");
  const isZWAD = pathname.startsWith("/ZWAD");
  const [setpoints, setSetpoints] = useState({
    "Flow Rate SP": "",
    "Flow Rate DB": "",
    "Field Pressure PID SP [Bypass Valve- Load/Unload SP]": "",
    "Field Pressure PID DB [Bypass Valve- Load/Unload]": "",
    "Desired RPM output min": "",
    "Desired RPM output max": "",
    "Field Control SP [Split Injection Output SP]": "",
    "Field Control DB [Split Injection Output DB]": "",
    "HI Field Control SP [Split Injection Override SP]": "",
    "HI Field Control DB [Split Injection Override DB]": "",
    "HI Field Control RPM SP [RPM Increase while Split Injection Override Active]":
      "",
  });
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");

  const fetchSetpoints = async () => {
    if (!unitId) return;
    try {
      if (data) {
        if (type === "C5" || type === "C5PLG") {
          setSetpoints((prev) => ({
            ...prev,
            "Desired RPM output min": data._41040 ?? "",
            "Desired RPM output max": data._41041 ?? "",
          }));
        }
        if (type === "C5E" || type === "C5EPLG") {
          setSetpoints((prev) => ({
            ...prev,
            "Desired RPM output min": data._41492 ?? "",
            "Desired RPM output max": data._41493 ?? "",
          }));
        }
        // if (type === "DO" || type === "DC"){
        //   setSetpoints((prev) => ({
        //     ...prev,
        //     "Desired RPM output min": data._41040 ?? data._41492,
        //     "Desired RPM output max": data._41041 ?? data._41493,
        //   }));
        // }
        setSetpoints((prev) => ({
          ...prev,
          "Flow Rate SP": parseFloat(data._41579 / 10) ?? "",
          "Flow Rate DB": parseFloat(data._41580 / 10) ?? "",
          "Field Pressure PID SP [Bypass Valve- Load/Unload SP]":
            parseFloat(data._41541) / 10 ?? "",
          "Field Pressure PID DB [Bypass Valve- Load/Unload]":
            parseFloat(data._41542) / 10 ?? "",
          "Field Control SP [Split Injection Output SP]":
            parseFloat(data._41001) / 10 ?? "",
          "Field Control DB [Split Injection Output DB]":
            parseFloat(data._41002) / 10 ?? "",
          "HI Field Control SP [Split Injection Override SP]":
            parseFloat(data._41714) / 10 ?? "",
          "HI Field Control DB [Split Injection Override DB]":
            parseFloat(data._41715) / 10 ?? "",
          "HI Field Control RPM SP [RPM Increase while Split Injection Override Active]":
            data._41702 ?? "",
        }));
      }
    } catch (err) {
      console.error("Failed to get setpoints:", err);
    }
  };

  useEffect(() => {
    if (unitId) {
      fetchSetpoints();
    }
  }, []);

  const validateFields = () => {
    const emptyFields = Object.entries(setpoints).filter(
      ([key, value]) => value === "" || value === null || value === undefined
    );
    return emptyFields.map(([key]) => key);
  };

  const updateSetpoints = async () => {
    const missingFields = validateFields();
    if (missingFields.length > 0) {
      toast.error(
        `Please fill in the following fields: ${missingFields.join(", ")}`,
        {
          autoClose: 5000,
        }
      );
      return;
    }
    try {
      const confirmed = window.confirm(
        "Are you sure you want to change the setpoints? Reminder: ALWAYS get Setpoints prior to doing the update. Please ignore if you already did"
      );
      if (!confirmed) return;
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        C5_REGISTERS
      );
      const baseline = {
        time: Number(initialResp.data.data?.time || 0),
        response: initialResp.data.data?.response || {},
      };
      console.log("Initial baseline time", baseline);
      const sp = (label) => parseFloat(setpoints[label]) || 0;
      const injSplitSP = sp(
        "Field Control SP [Split Injection Output SP]"
      );
      const injSplitDB = sp(
        "Field Control DB [Split Injection Output DB]"
      );
      const injSplitOverride = sp(
        "HI Field Control RPM SP [RPM Increase while Split Injection Override Active]"
      );
      if (injSplitSP > 150 || injSplitSP < 20) {
        console.log(
          setpoints["Field Control SP [Split Injection Output SP]"]
        );
        alert(
          "Field Control SP out-of-range. Value must be between 20 PSI and 150 PSI"
        );
        return;
      } else if (injSplitDB > 50 || injSplitDB < 1) {
        alert(
          "Field Control DB out-of-range. Value must be between 1 PSI and 50 PSI"
        );
        return;
      } else if (injSplitOverride > 2300) {
        alert(
          "HI Field Control RPM SP out-of-range. Value must be between 0 and 2300"
        );
        return;
      }
      let cmd = "S";
      cmd += `,${1000},${injSplitSP * 10}`;
      cmd += `,${1001},${injSplitDB * 10}`;
      cmd += `,${1578},${sp("Flow Rate SP") * 10}`;
      cmd += `,${1579},${sp("Flow Rate DB") * 10}`;
      cmd += `,${1540},${
        sp("Field Pressure PID SP [Bypass Valve- Load/Unload SP]") * 10
      }`;
      cmd += `,${1541},${
        sp("Field Pressure PID DB [Bypass Valve- Load/Unload]") * 10
      }`;
      cmd += `,${1039},${sp("Desired RPM output min")}`;
      cmd += `,${1040},${sp("Desired RPM output max")}`;
      cmd += `,${1491},${sp("Desired RPM output min")}`; // C5E
      cmd += `,${1492},${sp("Desired RPM output max")}`; // C5E
      cmd += `,${1713},${
        sp("HI Field Control SP [Split Injection Override SP]") * 10
      }`;
      cmd += `,${1714},${
        sp("HI Field Control DB [Split Injection Override DB]") * 10
      }`;
      cmd += `,${1701},${injSplitOverride}`;
      setProgressOpen(true);
      setProgressSuccess(false);
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
        { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`, },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Sending command:", cmd);
      setTimeout(() => {
        requestSetpoints(
          unitId,
          "P,1000,1,1001,1,1578,1,1579,1,1540,1,1541,1,1039,1,1040,1,1491,1,1492,1,1713,1,1714,1,1701,1",
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      }, 100);
    } catch (error) {
      console.log("Error to update setpoints", error);
    }
  };

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 14 }}>Setpoints</Typography>

        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            onClick={() =>
              getSetpoints(
                unitId,
                "P,1000,1,1001,1,1578,1,1579,1,1540,1,1541,1,1039,1,1040,1,1491,1,1492,1,1713,1,1714,1,1701,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen
              )
            }
          >
            Get Setpoints
          </Button>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            onClick={updateSetpoints}
          >
            Update
          </Button>
        </Box>

        {Object.entries(setpoints).map(([label, value]) => {
          return (
            <Box key={label} sx={{ paddingBlock: 0.75 }}>
              <Typography sx={{ fontSize: 13 }}>{label}</Typography>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                value={value}
                onChange={(e) =>
                  setSetpoints((prev) => ({
                    ...prev,
                    [label]: e.target.value,
                  }))
                }
                InputProps={{
                  sx: {
                    color: "#fff",
                    backgroundColor: "#1f2937",
                    padding: 0.2,
                    fontSize: 13,
                  },
                }}
              />
            </Box>
          );
        })}
      </Paper>
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Grid>
  );
};
